export default __webpack_public_path__ + "static/media/dog1.9d42bdc0.svg";